/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpdateRequestTitle } from './moduleUpdateRequestTitle';
import type { ModuleUpdateRequestMetadata } from './moduleUpdateRequestMetadata';
import type { ModuleUpdateRequestAuthor } from './moduleUpdateRequestAuthor';
import type { ModuleUpdateRequestState } from './moduleUpdateRequestState';
import type { ModuleUpdateRequestIsDeprecated } from './moduleUpdateRequestIsDeprecated';
import type { ModuleUpdateRequestMandates } from './moduleUpdateRequestMandates';

/**
 * to update a module
 */
export interface ModuleUpdateRequest {
  title?: ModuleUpdateRequestTitle;
  metadata?: ModuleUpdateRequestMetadata;
  author?: ModuleUpdateRequestAuthor;
  state?: ModuleUpdateRequestState;
  isDeprecated?: ModuleUpdateRequestIsDeprecated;
  mandates?: ModuleUpdateRequestMandates;
  propagateMandates?: boolean;
}
